export default function Footer() {
  return (
    <footer
      className="text-gray-100 text-center py-6"
      style={{ backgroundColor: "#0A1A44" }} // Sapphire Blue background
    >
      <p>
        © 2025{" "}
        <span className="font-semibold" style={{ color: "#C69A35" }}>
          Carnatic Cafe Inc.
        </span>{" "}
        – South Indian Restaurant | Oakville, Ontario, Canada
      </p>
    </footer>
  );
}
